export const CONSTANTS = {
  PAYMENT_LINK: 'https://pay.hotmart.com/Y104947408J?off=ao8e9qfi',
  PIXEL_ID: '1322033292727002',
  IMAGES: {
    MAIN: 'https://cdn.magicpatterns.com/uploads/xpgFJEBHZA6JpBwTXSV7st/mock_up_budines_itallia_(2).png',
    BONUS_1:
      'https://cdn.magicpatterns.com/uploads/6GMMSfwMn1VMZFUUXWhtPa/mock_up_budines_itallia_(4).png',
    BONUS_2:
      'https://cdn.magicpatterns.com/uploads/bygyzvgUaDy5MYxHwafnjH/mock_up_budines_itallia_(3).png',
    BONUS_3:
      'https://cdn.magicpatterns.com/uploads/uiC2s5jLjAxCRj7tMivtyV/mock_up_budines_itallia_(1).png',
    BONUS_4:
      'https://cdn.magicpatterns.com/uploads/jpoKr1uWNvCU8Guge2AG7R/mock_up_budines_itallia_.png',
  },
  PRICING: {
    ORIGINAL: '79,99',
    SALE: '14,99',
    TOTAL_VALUE: '130,95',
    SAVINGS_PERCENT: '81',
  },
}
